import React from 'react';
import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography} from '@mui/material';

export interface SamplesSummaryTableRow {
    key: string;
    cells: React.ReactNode[];
}

interface SamplesSummaryTableProps {
    headers: string[];
    rows: SamplesSummaryTableRow[];
    maxHeight?: number;
}

const SamplesSummaryTable = ({headers, rows, maxHeight = 600}: SamplesSummaryTableProps) => {
    return (
        <TableContainer
            sx={{
                maxHeight,
                overflowY: 'auto',
                overflowX: 'auto'
            }}>
            <Table stickyHeader>
                <TableHead>
                    <TableRow>
                        {headers.map(header => (
                            <TableCell key={header} sx={{whiteSpace: 'nowrap'}}>
                                <Typography variant="title" size="medium" fontWeight={600}>
                                    {header}
                                </Typography>
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map(row => (
                        <TableRow key={row.key}>
                            {row.cells.map((cell, idx) => (
                                <TableCell key={`${row.key}-${idx}`}>{cell}</TableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default SamplesSummaryTable;
